import type { Student } from '~/@entities/Student'
import type {
  DeleteUnitData,
  GetStudentIdOnLatestAssignmentData,
  GetStudentIdOnLatestScoringData,
  GetUnitIdsData,
  InsertUnitData,
  ScenarioUnitActionLogRequest,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptScenarioLatestStudentId, adaptScenarioUnitIds } from './adapters'
import type { ScenarioUnitId } from './schemas'

// actionType 을 빼면 서버가 WORKSHEET 로 기록·조회한다. 등록·삭제는 같은 (선생님, unitId) 에 대해 멱등이다.
// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 scenario/controller/ScenarioUnitActionLogController.kt 로 확인.
export type ScenarioActionLogBody = ScenarioUnitActionLogRequest

/** 로그인한 선생님이 수행한 시나리오 단계 키 목록 */
export const getScenarioUnitIds = async (meta?: RequestMeta): Promise<ScenarioUnitId[]> => {
  const body = await httpClient().get<GetUnitIdsData>('/scenario/action/log', { meta })
  return adaptScenarioUnitIds(body.data) ?? []
}

export const createScenarioActionLog = async (
  body: ScenarioActionLogBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<InsertUnitData>('/scenario/action/log', body, { meta })
}

export const deleteScenarioActionLog = async (
  body: ScenarioActionLogBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().delete<DeleteUnitData>('/scenario/action/log', { data: body, meta })
}

/** 선생님 반 학생 중 가장 최근에 학습지를 출제받은 학생 */
export const getScenarioLatestAssignedStudentId = async (
  meta?: RequestMeta,
): Promise<Student['id'] | null> => {
  const body = await httpClient().get<GetStudentIdOnLatestAssignmentData>(
    '/scenario/latest/assignment',
    { meta },
  )
  return adaptScenarioLatestStudentId(body.data)
}

/** 선생님 반 학생 중 가장 최근에 학습지 채점이 갱신된 학생 */
export const getScenarioLatestScoredStudentId = async (
  meta?: RequestMeta,
): Promise<Student['id'] | null> => {
  const body = await httpClient().get<GetStudentIdOnLatestScoringData>('/scenario/latest/scoring', {
    meta,
  })
  return adaptScenarioLatestStudentId(body.data)
}
